<script setup lang="ts">
  import { computed, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import enterpriseBanner1 from "~/assets/images/legal-data/enterpriseBanner1.png";
  import enterpriseBanner2 from "~/assets/images/legal-data/enterpriseBanner2.png";
  import professionalBanner1 from "~/assets/images/legal-data/professionalBanner1.png";
  import professionalBanner2 from "~/assets/images/legal-data/professionalBanner2.png";
  import CoreFunction from "~/components/aigc/CoreFunction.vue";
  import Anchor from "~/components/core/Anchor/Anchor.vue";
  import DataVipModal from "~/components/deli-module/DataVipModal.vue";
  import { useAnchor } from "~/composables/useAnchor";
  import { useAnchorShow } from "~/composables/useAnchorShow";
  import { SYSTEM_VERSION } from "~/enum/cache/cookie";
  import {
    AiFaLvZiXun,
    AiYueDuCaiPanWenShu,
    FaLvJianSuo,
    FaLvYanJiu,
    FaLvZiXun,
    FaLvZiXunTuiJian,
    HeGuiAi,
    HeTongShenCha,
    HeTongShengCheng,
    LvShiHan,
    ShengChengQiSuShu,
    WenShuAi,
  } from "~/enum/cdn";
  import { DATA_DOWNLOAD_URL, DATA_URL } from "~/env";
  import { useMainStore } from "~/stores";
  import Common from "~/utils/common";
  import Cookie from "~/utils/cookie";

  definePageMeta({
    layout: "nav-layout",
    middleware: ["search"],
  });

  // import professionalTable from "~/assets/images/legal-data/professiona-table.png";
  // import enterpriseTable from "~/assets/images/legal-data/enterprise-table.png";

  const { $req: req } = useNuxtApp();
  const { anchorShow } = useAnchorShow();
  const store = useMainStore() as any;
  const api = useApi();
  const route = useRoute();

  // 跳转律助
  // const toDls = (name: keyof typeof URL_LIST, hash?: string) => {
  //   if (name === "buyLogin") {
  //     location.replace(`${LOGIN_URL}&redirect=${encodeURIComponent(location.href + hash)}`);
  //     return;
  //   }
  //   location.href = URL_LIST[name];
  // };
  // 跳转法搜
  const toData = () => {
    const isEnterprise = route.path === "/search/enterprise";
    if (store.login) {
      api.switchVersion({ versionType: isEnterprise ? 2 : 1 }).then(() => {
        Cookie.set(SYSTEM_VERSION, isEnterprise ? "enterprise" : "professional");
        Common.openWin(DATA_URL);
      });
    } else {
      Cookie.set(SYSTEM_VERSION, isEnterprise ? "enterprise" : "professional");
      Common.openWin(isEnterprise ? `${DATA_URL}/enterprise` : DATA_URL);
    }
  };
  // 跳转 app 下载
  const toDownload = () => {
    Common.openWin(DATA_DOWNLOAD_URL);
  };

  // 特殊埋点
  const postSpecialTrack = () => {
    api.ai.specialTrack({ referer: window.location.href });
  };

  interface FunctionItem {
    functionName: string;
    functionDesc: string;
  }
  interface CoreFunctionProps {
    title: string;
    description?: string;
    url: string;
    imagePlacement: "left" | "right";
    mediaType?: "image" | "video";
    bg: "white" | "blue";
    anchorID: string;
    btnEmit: (...args: any[]) => void;
    functionList: FunctionItem[];
  }
  const professionalCoreList: CoreFunctionProps[] = [
    {
      title: "专业法律检索",
      url: FaLvJianSuo,
      anchorID: "anchor1",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "全域法律大数据：",
          functionDesc: "5亿+法律数据，知识产权和地产工程两大专业数据库，兼具深度、广度、速度",
        },
        {
          functionName: "智能语义检索：",
          functionDesc: "语义检索、关键词检索、长文本检索等多重检索模式加持，支持争议焦点、案情描述和法律文书直接搜索",
        },
        {
          functionName: "一次检索，多维呈现：",
          functionDesc: "一次检索， 案例、法规、观点、法讯同步输出，便于法律从业者全方位了解信息",
        },
      ],
    },
    {
      title: "AI阅读裁判文书",
      url: AiYueDuCaiPanWenShu,
      anchorID: "anchor2",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "智能摘要：",
          functionDesc:
            "基于案情快速生成摘要，一目了然诉讼请求、争议焦点、裁判依据、裁判结果等案件信息，快速掌握案件要点",
        },
        {
          functionName: "裁判要点：",
          functionDesc: "基于裁判文书快速生成裁判要点，帮助用户更快了解法院的判决思路和法律适用原则",
        },
        {
          functionName: "案例时间轴：",
          functionDesc: "通过数据可视化，AI会根据发生的时间和事件梳理案情，帮助用户快速了解案件经过",
        },
        {
          functionName: "智能报告：",
          functionDesc: "智能抽取裁判文书的内容要素 ，一键生成结合AI检索总结的类案检索报告",
        },
      ],
    },
    {
      title: "文本智能生成",
      url: ShengChengQiSuShu,
      anchorID: "anchor3",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "智能法律文书：",
          functionDesc:
            "根据案情描述，AI可自动总结诉求并生成起诉状、答辩状；根据客户需求，AI可快速生成法律意见书、律师函等法律文书",
        },
        {
          functionName: "合同起草：",
          functionDesc: "根据用户提供的信息和需求，AI可自动生成符合法律要求和惯例的的合同或协议",
        },
        {
          functionName: "文案智能撰写：",
          functionDesc: "不仅限于法律，AI还可辅助创作各类营销文案、发言稿、邮件和文章等",
        },
      ],
    },
    {
      title: "AI法律研究",
      url: FaLvYanJiu,
      anchorID: "anchor4",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "争议焦点分析：",
          functionDesc: "针对法律争议焦点，根据指令词，从不同维度进行分析",
        },
        {
          functionName: "案情分析：",
          functionDesc: "基于海量案例和问答数据训练，AI可理解并分析案情的复杂性，提供专业的法律依据和分析建议",
        },
        {
          functionName: "法律制度分析：",
          functionDesc: "小理AI学习大量的法律制度文件，为法律研究者深入不同法律制度提供智能辅助",
        },
        {
          functionName: "法律术语分析：",
          functionDesc: "基于阅读需求，上传文件，AI即可提炼生成案情摘要并归纳争议焦点，提升阅卷效率",
        },
      ],
    },
    {
      title: "AI+律师法律咨询",
      url: FaLvZiXun,
      anchorID: "anchor5",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "AI法律咨询：",
          functionDesc:
            "覆盖各种法律案由，无论是婚姻问题、房产纠纷还是交通事故，AI都可通过问题理解，正确引用法规和案例，帮助用户解答具体的法律问题",
        },
        {
          functionName: "律师智能匹配：",
          functionDesc: "根据用户的实际法律需求，智能匹配相应领域及要求的律师，提供个性化的法律解决方案",
        },
      ],
    },
    {
      title: "法律资讯推荐",
      url: FaLvZiXunTuiJian,
      anchorID: "anchor6",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "新法速递：",
          functionDesc: "收录人大、国务院、法院等各级机构最新颁布的法律法规和政府文件，了解最新立法动态",
        },
        {
          functionName: "法律观点：",
          functionDesc: "集成知名律所和机构发表的最新观点，打造法律人专属的知识分享社区",
        },
        {
          functionName: "全国商机：",
          functionDesc: "实时收录全国各地采购和招投标商机内容 ，助力律师洞察趋势、把握商机",
        },
        {
          functionName: "法讯订阅：",
          functionDesc: "整合不同媒体平台、不同领域的最新法律资讯，提供个性化订阅服务",
        },
      ],
    },
  ];
  const enterpriseCoreList: CoreFunctionProps[] = [
    {
      title: "AI法律咨询",
      description: "7*24小时智能法律咨询，助您轻松应对各种企业法律问题",
      url: AiFaLvZiXun,
      anchorID: "anchor1",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "",
          functionDesc: "支持7×24小时问答服务，不限次数。",
        },
        {
          functionName: "",
          functionDesc: "覆盖政策解读、劳动用工、合同纠纷、公司治理等法律领域。",
        },
        {
          functionName: "",
          functionDesc: "回答内容基于5亿+法律数据与司法实践，精准权威。",
        },
        {
          functionName: "",
          functionDesc: "提供答案+法律依据双输出，便于内部沟通和决策。",
        },
      ],
    },
    {
      title: "合同审查",
      description: "一分钟读懂整份合同，三分钟标出风险重点！",
      url: HeTongShenCha,
      anchorID: "anchor2",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "快速解析合同：",
          functionDesc: "AI秒读整份合同，基于海量法律知识库和行业标准，快速完成条款梳理与结构解析，不再人工逐页翻阅。",
        },
        {
          functionName: "自动审查风险：",
          functionDesc:
            "一键高亮关键条款与风险点，精准识别付款、违约、期限、管辖权等重点内容，自动标记潜在陷阱与合规漏洞，查得准、改得快。",
        },
      ],
    },
    {
      title: "合同生成",
      description: "一句话起草，秒出专业合同！",
      url: HeTongShengCheng,
      anchorID: "anchor3",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "智能高效生成：",
          functionDesc:
            "依托海量真实合同样本与行业标准模板，高效生成结构严谨、内容精准、格式规范的合同文本，大幅提升合同起草效率与准确性。",
        },
        {
          functionName: "条款灵活定制：",
          functionDesc:
            "支持多种合同类型与业务场景，自动生成关键条款（如付款、期限、违约、保密等），可根据企业实际需求灵活调整，确保合同文本合规合法。",
        },
      ],
    },
    {
      title: "合规AI",
      description: "企业的专属“合规顾问”，随时在线！",
      url: HeGuiAi,
      anchorID: "anchor4",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "合规咨询：",
          functionDesc:
            "为企业提供专业、及时的合规咨询服务。日常法规解读、政策咨询，以及合规风险评估都能快速响应，帮助企业全面理解并遵守相关法规，降低合规风险，保障企业稳定发展。",
        },
        {
          functionName: "法规洞察：",
          functionDesc:
            "为用户提供详尽的法规解读和政策动态。通过一键咨询，企业可轻松掌握复杂法规要点，确保合规措施的科学合理性，提高效率，助力企业合法合规运营。",
        },
      ],
    },
    {
      title: "文书AI",
      url: WenShuAi,
      anchorID: "anchor5",
      bg: "blue",
      imagePlacement: "left",
      btnEmit: toData,
      functionList: [
        {
          functionName: "文书生成：",
          functionDesc:
            "基于专业法律大模型，智能生成公司章程、股权激励计划、诉讼文书等标准化法律文书。用户输入关键要素，系统自动匹配法律条款并生成结构化文本。",
        },
        {
          functionName: "文档分析：",
          functionDesc:
            "对文档进行深度解析，提取关键信息，识别潜在风险点。并可解析用户上传的文档再次进行文书生成，例如根据用户上传的起诉状生成对应的答辩状。",
        },
      ],
    },
    {
      title: "律师函",
      url: LvShiHan,
      anchorID: "anchor6",
      bg: "white",
      imagePlacement: "right",
      btnEmit: toData,
      functionList: [
        {
          functionName: "服务内容：",
          functionDesc: "资金拖欠、权益侵害、合同违约等全方位咨询；为企业提供合规、高效的律师函服务。",
        },
        {
          functionName: "执业律师背书：",
          functionDesc: "由入驻平台的执业律师起草并加盖律所签章，确保函件符合法律及司法实践要求。",
        },
        {
          functionName: "全流程跟踪：",
          functionDesc: "平台下单→律师接单→沟通案情→文书制作→函件跟踪确认→服务评价。",
        },
      ],
    },
  ];
  const coreList = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseCoreList : professionalCoreList;
  });
  const professionalAnchorList = [
    {
      id: "anchor1",
      title: "专业法律检索",
      icon: "gaojijiansuo12",
      activeIcon: "gaojijiansuo1",
    },
    {
      id: "anchor2",
      title: "AI阅读裁判文书",
      icon: "wenshu12",
      activeIcon: "wenshu13",
    },
    {
      id: "anchor3",
      title: "文本智能生成",
      icon: "24gf-fileText1",
      activeIcon: "24gf-fileText17",
    },
    {
      id: "anchor4",
      title: "AI法律研究",
      icon: "xueshuyanjiu11",
      activeIcon: "xueshuyanjiu13",
    },
    {
      id: "anchor5",
      title: "AI+律师法律咨询",
      icon: "zixun111",
      activeIcon: "zixun113",
    },
    {
      id: "anchor6",
      title: "法律资讯推荐",
      icon: "xinwenzixun1",
      activeIcon: "xinwenzixun11",
    },
    {
      id: "anchor7",
      title: "产品优势",
      icon: "xunzhang1",
      activeIcon: "xunzhang12",
    },
  ];
  const enterpriseAnchorList = [
    {
      id: "anchor1",
      title: "AI法律咨询",
      icon: "gaojijiansuo12",
      activeIcon: "gaojijiansuo1",
    },
    {
      id: "anchor2",
      title: "合同审查",
      icon: "wenshu12",
      activeIcon: "wenshu13",
    },
    {
      id: "anchor3",
      title: "合同生成",
      icon: "24gf-fileText1",
      activeIcon: "24gf-fileText17",
    },
    {
      id: "anchor4",
      title: "合规AI",
      icon: "xueshuyanjiu11",
      activeIcon: "xueshuyanjiu13",
    },
    {
      id: "anchor5",
      title: "文书AI",
      icon: "zixun111",
      activeIcon: "zixun113",
    },
    {
      id: "anchor6",
      title: "律师函",
      icon: "xinwenzixun1",
      activeIcon: "xinwenzixun11",
    },
    {
      id: "anchor7",
      title: "产品优势",
      icon: "xunzhang1",
      activeIcon: "xunzhang12",
    },
  ];
  const anchorList = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseAnchorList : professionalAnchorList;
  });
  const { curAnchorID } = useAnchor(anchorList.value);
  const icons = [
    {
      icon: "Group2648",
      name: "案例",
    },
    {
      icon: "Group2649",
      name: "法规",
    },
    {
      icon: "Group2656",
      name: "观点",
    },
    {
      icon: "Group2650",
      name: "法讯",
    },
    {
      icon: "hangzhengchufa1",
      name: "行政处罚",
    },
    {
      icon: "Group26491",
      name: "检察文书",
    },
    {
      icon: "tianpingcfs11",
      name: "法官",
    },
    {
      icon: "Group26561",
      name: "律师",
    },
    {
      icon: "lvsuoguanli1",
      name: "律所",
    },
  ];
  const advantageList = [
    {
      name: "全域法律数据",
      iconList: [
        {
          icon: "shuju1",
          name: "5亿+法律数据",
        },
        {
          icon: "zhishichanquan1",
          name: "知识产权专业库",
        },
        {
          icon: "zhuanyeku1",
          name: "地产工程专业库",
        },
        {
          icon: "shishishuju1",
          name: "数据实时更新",
        },
        {
          icon: "changguijiansuo1",
          name: "多重检索方式",
        },
        {
          icon: "shujujieguo1",
          name: "结果多维呈现",
        },
      ],
    },
    {
      name: "全域法律应用",
      iconList: [
        {
          icon: "hetong-31",
          name: "智能合同服务",
        },
        {
          icon: "erjitubiao-jiansuozhongxin-jiansuodingyue-1",
          name: "法律研究辅助",
        },
        {
          icon: "fenxi6",
          name: "案情分析预测",
        },
        {
          icon: "lvshi",
          name: "日常法律咨询",
        },
        {
          icon: "falv-31",
          name: "律师智能推荐",
        },
        {
          icon: "zhishi-21",
          name: "智能法律文书",
        },
      ],
    },
    {
      name: "专有模型部署",
      iconList: [
        {
          icon: "damoxingjiaosemoban",
          name: "通用大模型",
        },
        {
          icon: "falv-4",
          name: "法律大模型",
        },
        {
          icon: "beian",
          name: "国家算法备案",
        },
      ],
    },
  ];

  const enterpriseAdvantageList = [
    {
      title: "全域法律数据",
      text: "实时更新的法律数据库，始终保持专业领先平台集成5亿+法律法规、案例与政策资讯，动态更新、权威可查，为企业提供始终可靠的法律支持。",
      icon: "shuju1-hg0am2e9",
    },
    {
      title: "AI高效赋能",
      text: "AI赋能，效率大幅提升AI赋能，效率大幅提升，轻松应对法律事务 依托大语言模型与语义检索引擎，平台实现快速响应、精准定位、智能处理，合同审查、法律咨询等操作，可大量节省时间。",
      icon: "damoxingjiaosemoban-hg0am2e9",
    },
    {
      title: "一站式法律服务",
      text: "高性价比的企业法律解决方案 集成法律咨询、合同生成、审查、文书起草、律师服务于一体，企业无需多平台切换，一站满足企业法律需求。",
      icon: "falv-4-hg0am2d4",
    },
    {
      title: "AI与律师协同服务",
      text: "“AI+律师”协同闭环，线上线下全场景结合 融合AI智能处理与专业律师服务，既能智能解答常见问题，又能落地处理复杂案件、起草函件、应诉维权，实现真正的法律服务闭环。",
      icon: "lvshi-hg0am2d8",
    },
  ];

  // const tableImage = computed(() => {
  //   return route.value.path === "/search/enterprise" ? enterpriseTable : professionalTable;
  // });

  // 购买弹窗
  const buyVisible = ref(false);
  // 购买
  const onBuy = () => {
    // req
    //   .auth()
    //   .then(() => {
    //     buyVisible.value = true;
    //   })
    //   .catch(() => {
    //     toDls("buyLogin", "#use");
    //   });
    buyVisible.value = true;
  };

  // 当前选中的tab
  const activeTab = ref<string>(route.path === "/search/enterprise" ? "COMPANY" : "SVIP");
  // 设置当前选中的 tab
  const setActiveTab = (tab: string): void => {
    activeTab.value = tab;
    loadPlan();
  };

  // 当前选中的 planId
  const currentPlanId = ref<string>("");
  // 设置当前选中的 planId
  const setCurrentPlanId = (planId: string): void => {
    currentPlanId.value = planId;
  };

  // 计划列表
  const planList = ref<any[]>([]);
  // 加载计划
  const loadPlan = () => {
    const param = {
      type: activeTab.value,
    };
    api.getPlanList(param).then((res: any) => {
      if (res && res.length > 0) {
        planList.value = res;
        currentPlanId.value = res[0].planId;
      }
    });
  };

  const vipImageUrl = ref("");
  const getVipImageUrl = () => {
    req.getVipImageUrl({ code: "PORTAL_PAY_IMG" }).then((res: any) => {
      vipImageUrl.value = res[0].value;
    });
  };

  // 专业版数据
  const professionalData = ref({
    title: "- 得理法搜 -",
    subTitle1: "法律数据新一代智能引擎",
    subTitle2: "法律难题，就找得理法搜",
    banner1: professionalBanner1,
    banner2: professionalBanner2,
  });
  // 企业版数据
  const enterpriseData = ref({
    title: "- 得理法搜企业版 -",
    subTitle1: "“AI+律师”集成服务",
    subTitle2: "护航企业健康发展",
    banner1: enterpriseBanner1,
    banner2: enterpriseBanner2,
  });

  const data = computed(() => {
    return route.path === "/search/enterprise" ? enterpriseData.value : professionalData.value;
  });

  onMounted(() => {
    getVipImageUrl();
    loadPlan();
    postSpecialTrack();
  });
</script>

<template>
  <div class="legal-data">
    <Anchor v-show="anchorShow" :id="curAnchorID" :anchor="anchorList" />
    <div class="legal-data-banner" :style="{ backgroundImage: `url(${data.banner1})` }">
      <div class="legal-data-banner-content">
        <p>{{ data.title }}</p>
        <p>{{ data.subTitle1 }}</p>
        <p>{{ data.subTitle2 }}</p>
        <div class="legal-data-btns">
          <a-button @click="toData">免费体验</a-button>
          <a-button class="app-download-btn app-download-mobile" @click="toDownload">APP下载</a-button>
          <a-button class="app-download-btn app-download-pc">APP下载</a-button>
          <img class="qrcode" src="~/assets/images/qrcode/legal-search.png" />
        </div>
      </div>
    </div>
    <div id="anchor-start" class="legal-data-icons">
      <div v-for="(item, idx) of icons" :key="idx" class="legal-data-icon">
        <icon-font :type="item.icon" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="legal-data-show" :style="{ backgroundImage: `url(${data.banner1})` }">
      <img class="legal-data-show-image" :src="data.banner2" />
    </div>
    <CoreFunction v-for="(item, idx) of coreList" v-bind="item" :key="`coreList${idx}`" />
    <div class="legal-data-advantage">
      <h2 id="anchor7" class="legal-data-advantage-title">产品优势</h2>
      <div v-if="route.path === '/search/enterprise'" class="legal-data-enterprise-box">
        <div v-for="(item, idx) of enterpriseAdvantageList" :key="idx" class="legal-data-enterprise-card">
          <icon-font :type="item.icon" />
          <div class="legal-data-enterprise-card-title">{{ item.title }}</div>
          <div class="legal-data-enterprise-card-text">{{ item.text }}</div>
        </div>
      </div>
      <div v-else class="legal-data-advantage-box">
        <div
          v-for="(item, idx) of advantageList"
          :key="`advantageList${idx}`"
          class="legal-data-advantage-card"
          :class="`legal-data-advantage-card${idx + 1}`">
          <h3>{{ item.name }}</h3>
          <div v-for="icon of item.iconList" :key="icon.icon" class="legal-data-advantage-card-icon">
            <icon-font :type="icon.icon" />
            <span>{{ icon.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-end" class="legal-data-vip">
      <h2 class="legal-data-vip-title">法搜订阅会员</h2>
      <div class="legal-data-vip-card">
        <div class="legal-data-vip-card-content">
          <div class="legal-data-vip-tabs" :class="[`legal-data-${activeTab}-bg`]">
            <div class="tab" :class="{ active: activeTab === 'SVIP' }" @click="setActiveTab('SVIP')"></div>
            <div class="tab" :class="{ active: activeTab === 'VIP' }" @click="setActiveTab('VIP')"></div>
            <div class="tab" :class="{ active: activeTab === 'COMPANY' }" @click="setActiveTab('COMPANY')"></div>
          </div>
          <div v-show="activeTab !== 'COMPANY'" class="legal-data-vip-plans">
            <div class="vip-plans-container">
              <div
                v-for="plan in planList"
                :key="plan.planId"
                class="plan-card"
                :class="{
                  'plan-card-active': currentPlanId === plan.planId,
                }"
                @click="setCurrentPlanId(plan.planId)">
                <div v-if="plan?.leftTag" class="x-data-vip-box-main-plan-leftTag">{{ plan?.leftTag }}</div>
                <div v-if="plan?.rightTag" class="x-data-vip-box-main-plan-rightTag">{{ plan?.rightTag }}</div>
                <!-- <div v-if="['l', 'm', 'c'].includes(plan.planId)" class="limited-offer-tag">限时优惠</div>
                <div v-if="['p'].includes(plan.planId)" class="limited-offer-tag">推荐</div> -->
                <div class="plan-duration">{{ plan.planName }}</div>
                <div class="plan-price"> <span class="currency">¥</span>{{ plan.planPrice / 100 }} </div>
                <div v-if="plan.sourcePrice" class="plan-original-price">¥{{ plan.sourcePrice / 100 }}</div>
              </div>
            </div>
            <div class="vip-buy-btn">
              <a-button type="primary" @click="onBuy">立即订阅</a-button>
            </div>
          </div>
          <div v-show="activeTab === 'COMPANY'" class="company-vip-card">
            <div class="company-vip-box">
              <div
                v-for="item in planList"
                :key="item.planId"
                class="company-vip-item"
                :class="[
                  {
                    'company-vip-recommend': item.planId === 'COMPANY_l',
                    'company-vip-item-selected': item.planId === currentPlanId,
                  },
                ]"
                @click="setCurrentPlanId(item.planId)">
                <icon-font v-if="item.planId === 'COMPANY_l'" class="company-vip-item-icon" type="module-a-Slice541" />
                <icon-font v-else class="company-vip-item-icon" type="module-a-Slice5411" />
                <div class="company-vip-box">
                  <div v-if="item?.leftTag" class="x-data-vip-box-main-plan-leftTag">{{ item?.leftTag }}</div>
                  <div v-if="item?.rightTag" class="x-data-vip-box-main-plan-rightTag">{{ item?.rightTag }}</div>
                  <div class="company-vip-right">{{ `企业会员·${item.planName}` }}</div>
                  <div class="company-vip-left">
                    <div class="company-vip-left-price">
                      <span class="company-vip-left-price-plan">{{ item.planPrice / 100 }}</span>
                      <span class="company-vip-left-price-source">¥{{ item.sourcePrice / 100 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="vip-buy-btn">
              <a-button type="primary" @click="onBuy">立即订阅</a-button>
            </div>
          </div>
        </div>
        <img class="tw-mt-[75px] tw-w-full" src="~/assets/images/legal-data/title.png" alt="" />
        <div ref="customerModalRef">
          <a-tooltip
            :align="{ points: ['tc', 'bc'], offset: [0, -8] }"
            trigger="click"
            :get-popup-container="() => $refs.customerModalRef"
            overlay-class-name="customer-tips-overlay">
            <div class="">
              <img
                class="tw-mx-auto tw-mb-[42px] tw-mt-[30px] tw-block tw-h-[53px] tw-cursor-pointer"
                src="~/assets/images/legal-data/gift.png"
                alt="" />
            </div>
            <template #title>
              <div>
                <div
                  class="customer-code-pine tw-bg-[url('~/assets/images/legal-data/customer-qr-code.png')] tw-bg-cover">
                </div>
              </div>
            </template>
          </a-tooltip>
        </div>

        <img class="legal-data-vip-card-footer" :src="vipImageUrl" />
        <!-- <div class="lawyer-letter">
          <div class="lawyer-letter-title">律师函：</div>
          <div class="lawyer-letter-box">
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">原价：</div>
              <div class="lawyer-letter-item-content"> <strong style="color: #fb7005">488</strong> 元/次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业会员：</div>
              <div class="lawyer-letter-item-content"> <strong style="color: #fb7005">388</strong> 元/次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业包年用户：</div>
              <div class="lawyer-letter-item-content"> 免费赠送 <strong style="color: #2051f3">1</strong> 次 </div>
            </div>
            <div class="lawyer-letter-item">
              <div class="lawyer-letter-item-label">企业三年用户：</div>
              <div class="lawyer-letter-item-content"> 免费赠送 <strong style="color: #2051f3">5</strong> 次 </div>
            </div>
          </div>
        </div>
        <div class="legal-data-vip-card-footer-tips">
          <div class="tips-title">合同审查次数：</div>
          <div class="legal-data-vip-card-footer-tips-box">
            <div class="vip-times"
              >包月用户每月<strong>5次</strong>，包年用户每年<strong>60次</strong>，三年用户<strong>200次</strong></div
            >
            <div class="vip-times">企业会员包年用户每年<strong>120次</strong>，三年用户<strong>400次</strong></div>
          </div>
        </div> -->
      </div>
    </div>
    <DataVipModal
      v-if="buyVisible"
      v-model:open="buyVisible"
      :default-type="activeTab"
      :default-plan-id="currentPlanId" />
  </div>
</template>

<style scoped lang="less">
  .legal-data {
    --banner-title-text: 86px;
    --banner-title-leading: 101px;
    --banner-sub-title-text: 36px;
    --banner-sub-title-leading: 42px;
    --banner-btn-text: 24px;
    --banner-btn-leading: 28px;
    --banner-btn-width: 200px;
    --banner-btn-height: 72px;
    --banner-btn-download-pc: block;
    --banner-btn-download-mobile: none;
    --vip-card-rounded: 16px;
    --vip-card-border: 4px;
    --vip-tip-rounded: 12px;
    --vip-tip-text: 16px;
    --vip-tip-leading: 19px;
    --vip-time-text: 28px;
    --vip-time-leading: 33px;
    --vip-money-text: 84px;
    --vip-money-leading: 93px;
    --vip-money-prefix-text: 36px;
    --vip-money-prefix-leading: 42px;
    --vip-original-text: 22px;
    --vip-original-leading: 26px;
    --vip-btn-text: 28px;
    --vip-btn-leading: 33px;
    --vip-icon: 36px;
    --vip-icon-text: 24px;
    --vip-icon-leading: 28px;
    --vip-card-padding: 80px 166px;
    --plan-card-h: 302px;
    --vip-gap: 0 40px;
    --vip-plans-padding: 48px 64px 0 64px;
    --plan-card-height: 198px;
    --grid-template-columns: repeat(4, 1fr);
    --flex-direction: row;
    --contact-item-width: 320px;
    --flex-gap: 16px;
    --org-benefits-title-width: 405px;
    --org-benefits-title-aspect: 405/32;
    --rights-title-font-size: 36px;
    --rights-title-box-line-width: 35%;
    --limited-offer-tag-padding: 5px 19px;
    --plan-card-margin-bottom: 8px;

    min-width: 320px;
    overflow-x: auto;

    @media (max-width: 1536px) {
      --vip-card-padding: 60px 77px;
    }

    @media (max-width: 1280px) {
      --vip-card-padding: 50px 38px;
      --rights-title-font-size: 36px;
      --rights-title-box-line-width: 30%;
    }

    @media (max-width: 1024px) {
      --banner-title-text: 66px;
      --banner-title-leading: 79px;
      --vip-card-padding: 40px 26px;
      --vip-gap: 0 20px;
      --contact-item-width: 320px;
      --rights-title-font-size: 30px;
      --rights-title-box-line-width: 28%;
      --limited-offer-tag-padding: 3px 12px;
    }

    @media (max-width: 768px) {
      --banner-title-text: 56px;
      --banner-title-leading: 66px;
      --banner-btn-text: 16px;
      --banner-btn-leading: 20px;
      --banner-btn-width: 126px;
      --banner-btn-height: 42px;
      --banner-btn-download-pc: none;
      --banner-btn-download-mobile: block;
      --vip-tip-text: 12px;
      --vip-tip-leading: 16px;
      --vip-card-rounded: 8px;
      --vip-tip-rounded: 6px;
      --vip-card-border: 2px;
      --vip-time-text: 20px;
      --vip-time-leading: 23px;
      --vip-money-text: 48px;
      --vip-money-leading: 48px;
      --vip-money-prefix-text: 24px;
      --vip-money-prefix-leading: 24px;
      --vip-original-text: 16px;
      --vip-original-leading: 19px;
      --vip-btn-text: 20px;
      --vip-btn-leading: 23px;
      --vip-icon: 22px;
      --vip-icon-text: 18px;
      --vip-icon-leading: 21px;
      --plan-card-h: 224px;
      --vip-gap: 0 8px;
      --vip-card-padding: 30px 20px;
      --vip-plans-padding: 38px 54px 0 54px;
      --grid-template-columns: repeat(2, 1fr);
      --contact-item-width: 290px;
      --rights-title-font-size: 24px;
      --rights-title-box-line-width: 29%;
    }

    @media (max-width: 640px) {
      --banner-title-text: 38px;
      --banner-title-leading: 46px;
      --vip-card-padding: 20px 20px;
      --plan-card-height: 174px;
      --vip-plans-padding: 30px 44px 0 44px;
      --contact-item-width: 320px;
      --flex-direction: column;
      --flex-gap: 0;
      --org-benefits-title-width: 385px;
      --org-benefits-title-aspect: 385/32;
      --rights-title-font-size: 20px;
      --rights-title-box-line-width: 25%;
      --limited-offer-tag-padding: 2.6px 10px;
    }

    @media (max-width: 480px) {
      --banner-sub-title-text: 26px;
      --banner-sub-title-leading: 32px;
      --banner-title-text: 28px;
      --banner-title-leading: 36px;
      --vip-time-text: 12px;
      --vip-time-leading: 16px;
      --vip-money-text: 24px;
      --vip-money-leading: 24px;
      --vip-money-prefix-text: 12px;
      --vip-money-prefix-leading: 16px;
      --vip-original-text: 12px;
      --vip-original-leading: 12px;
      --vip-btn-text: 20px;
      --vip-btn-leading: 23px;
      --vip-icon: 22px;
      --vip-icon-text: 14px;
      --vip-icon-leading: 16px;
      --plan-card-h: 160px;
      --vip-card-padding: 10px 20px;
      --plan-card-height: 154px;
      --vip-plans-padding: 24px 34px 0 34px;
      --grid-template-columns: repeat(1, 1fr);
      --contact-item-width: 320px;
      --org-benefits-title-width: 305px;
      --org-benefits-title-aspect: 305/32;
      --rights-title-font-size: 18px;
      --rights-title-box-line-width: 19%;
      --limited-offer-tag-padding: 5px 19px;
      --plan-card-margin-bottom: 0;
    }

    @media (max-width: 400px) {
      --contact-item-width: 280px;
      --org-benefits-title-width: 290px;
      --org-benefits-title-aspect: 290/32;
      --rights-title-box-line-width: 19%;
    }

    @media (max-width: 360px) {
      --contact-item-width: 260px;
      --org-benefits-title-width: 265px;
      --org-benefits-title-aspect: 265/32;
      --rights-title-box-line-width: 15%;
      --limited-offer-tag-padding: 2.6px 10px;
    }

    .legal-data-banner {
      height: 945px;
      overflow: hidden;
      background-position: center;
      background-size: cover;

      .legal-data-banner-content {
        width: min-content();
        min-width: 100%;
        margin: 172px auto 0;

        p {
          padding: 0 32px;
          margin-bottom: 0;
          font-size: var(--banner-title-text);
          font-weight: bolder;
          line-height: var(--banner-title-leading);
          color: #fff;
          text-align: center;

          &:nth-of-type(1) {
            margin-bottom: 24px;
            font-size: var(--banner-sub-title-text);
            line-height: var(--banner-sub-title-leading);
          }
        }

        .legal-data-btns {
          position: relative;
          display: flex;
          gap: 28px;
          align-items: center;
          justify-content: center;
          width: min-content;
          margin: 167px auto 0;

          .ant-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: var(--banner-btn-width);
            height: var(--banner-btn-height);
            font-size: var(--banner-btn-text);
            font-weight: 600;
            line-height: var(--banner-btn-leading);
            color: #fff;
            background: linear-gradient(90deg, #3858ff 0%, #66f 100%);
            border: none !important;
            border-radius: 4px;
          }

          .app-download-btn {
            color: #0a5cff;
            background-color: white;
            background-image: none;
          }

          .app-download-mobile {
            display: var(--banner-btn-download-mobile);
          }

          .app-download-pc {
            display: var(--banner-btn-download-pc);

            &:hover {
              & ~ .qrcode {
                width: 155px;
              }
            }
          }

          .qrcode {
            position: absolute;
            top: 50%;
            right: 0;
            width: 0;
            height: 155px;
            transform: translateX(calc(100% + 28px)) translateY(-50%);
          }
        }
      }
    }

    .legal-data-icons {
      display: flex;
      flex-wrap: wrap;
      gap: 16px 64px;
      align-items: center;
      justify-content: center;
      min-height: 90px;
      padding: 28px 0;
      font-size: 24px;
      line-height: 28px;
      color: #fff;
      background: linear-gradient(90deg, #7484ed 0%, #61b8ff 45%, #7371f9 100%);

      .legal-data-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        .anticon {
          margin-right: 8px;
          font-size: 24px;
        }

        &:last-of-type {
          &::after {
            margin-left: 17px;
            content: "...";
          }
        }
      }
    }

    .legal-data-show {
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 1080px;
      padding: 90px 0;
      background-position: center center;
      background-size: cover;

      .legal-data-show-image {
        width: 80.89%;
        height: auto;
        aspect-ratio: 1553 / 900;
        object-fit: cover;
      }
    }

    .legal-data-advantage {
      min-height: 933px;
      padding: 0 16px;
      overflow: hidden;
      background: rgba(206, 218, 255, 54%);

      .legal-data-advantage-title {
        position: relative;
        margin-top: 96px;
        margin-bottom: 72px;
        font-size: 40px;
        font-weight: bold;
        line-height: 47px;
        color: #333;
        text-align: center;

        &::after {
          position: absolute;
          bottom: -13px;
          left: 50%;
          display: block;
          width: 32px;
          height: 6px;
          content: "";
          background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
          transform: translateX(-50%);
        }
      }

      .legal-data-enterprise-box {
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        justify-content: center;
        margin: 0 auto;

        .legal-data-enterprise-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 314px;
          height: 492px;
          padding: 0 37px;
          background: #fff;
          border-style: solid;
          border-width: 6px 0 0;
          border-radius: 8px;
          border-image: linear-gradient(90deg, rgba(10, 92, 255, 100%), rgba(102, 102, 255, 100%)) 6 6;
          box-shadow: 0 8px 32px 0 rgba(168, 179, 255, 20%);

          .anticon {
            margin-top: 96px;
            font-size: 72px;
          }

          .legal-data-enterprise-card-title {
            margin-top: 48px;
            margin-bottom: 24px;
            font-size: 24px;
            font-weight: 600;
          }

          .legal-data-enterprise-card-text {
            font-size: 18px;
            color: #5a5d66;
          }
        }
      }

      .legal-data-advantage-box {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
        max-width: 1736px;
        margin: 0 auto;

        .legal-data-advantage-card {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 514px;
          height: 862px;
          padding: 56px 0;
          background: #fff;
          border-radius: 8px;

          &:last-of-type {
            grid-template-columns: auto;

            h3 {
              grid-column: span 1;
            }
          }

          h3 {
            grid-column: span 2;
            justify-self: center;
            margin-bottom: 0;
            font-size: 40px;
            font-weight: 600;
            line-height: 47px;
            color: #333;
          }

          .legal-data-advantage-card-icon {
            display: flex;
            flex-direction: column;
            align-items: center;

            .anticon {
              margin-bottom: 24px;
              font-size: 72px;
            }

            span {
              font-size: 20px;
              font-weight: 400;
              line-height: 23px;
              color: #5a5d66;
            }
          }
        }
      }
    }

    .legal-data-vip {
      min-height: 1080px;
      padding: 0 16px 206px;
      overflow: hidden;
      background: rgba(206, 218, 255, 54%);

      .legal-data-vip-title {
        position: relative;
        margin-top: 96px;
        margin-bottom: 72px;
        font-size: 40px;
        font-weight: bold;
        line-height: 47px;
        color: #333;
        text-align: center;

        &::after {
          position: absolute;
          bottom: -13px;
          left: 50%;
          display: block;
          width: 32px;
          height: 6px;
          content: "";
          background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
          transform: translateX(-50%);
        }
      }

      .legal-data-vip-card {
        width: 100%;
        max-width: 1736px;
        padding: var(--vip-card-padding);
        margin: 0 auto;
        background: #fff;
        border-radius: 16px;

        .legal-data-vip-card-content {
          width: 100%;
          height: fit-content;

          .legal-data-vip-tabs {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: fit-content;

            .tab {
              flex: 1;
              height: 80%;
              padding: 10px 20px;
              font-size: 18px;
              text-align: center;
              cursor: pointer;

              &.active {
                font-weight: bold;
                color: #0a5cff;
              }
            }

            &.legal-data-SVIP-bg {
              aspect-ratio: 1404/104;
              background: url("~/assets/images/legal-data/data-svip.svg");
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }

            &.legal-data-VIP-bg {
              aspect-ratio: 1404/104;
              background: url("~/assets/images/legal-data/data-vip.svg");
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }

            &.legal-data-COMPANY-bg {
              aspect-ratio: 1404/104;
              background: url("~/assets/images/legal-data/data-org.svg");
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }

          .vip-buy-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 60px 0;

            .ant-btn {
              width: 480px;
              height: 58px;
              font-size: 20px;
              font-weight: 500;
              background: #0a6cff;
              border-radius: 30px;
            }
          }

          .legal-data-vip-plans {
            width: 100%;
            // padding: 48px 64px 0 64px;
            padding: var(--vip-plans-padding);
            background-color: #fff8f0;

            .vip-plans-container {
              display: grid;
              grid-template-columns: var(--grid-template-columns);
              gap: 25px;
              width: 100%;

              .plan-card {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: var(--plan-card-height);
                text-align: center;
                cursor: pointer;
                background-color: #fff;
                border: 2px solid #e79466;
                border-radius: 24px;

                .x-data-vip-box-main-plan-leftTag {
                  position: absolute;
                  top: 0;
                  left: 0;
                  padding: 4px 11px;
                  font-size: 12px;
                  color: #9b4f2e;
                  background: #ffe1d0;
                  border-radius: 23px 0;
                }

                .x-data-vip-box-main-plan-rightTag {
                  position: absolute;
                  top: -8px;
                  right: -4px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 34px;
                  height: 34px;
                  font-size: 8px;
                  font-weight: 500;
                  color: #a18b69;
                  text-align: center;
                  white-space: normal;
                  background: url("~/assets/icons/deli-module/pay-right-tag.png");
                  background-size: cover;
                }

                .limited-offer-tag {
                  position: absolute;
                  top: -1px;
                  left: -1px;
                  padding: var(--limited-offer-tag-padding);
                  font-size: 16px;
                  color: #fff;
                  background-color: #ed6425;
                  border-top-left-radius: 24px;
                  border-bottom-right-radius: 24px;
                }

                .plan-duration {
                  margin-bottom: var(--plan-card-margin-bottom);
                  font-size: 20px;
                  color: #683510;
                }

                .plan-price {
                  margin-bottom: var(--plan-card-margin-bottom);
                  font-size: 48px;
                  font-weight: 500;
                  color: #9b4f2e;

                  .currency {
                    font-size: 32px;
                  }
                }

                &.plan-card-active {
                  background: linear-gradient(135deg, #fff6e9 0%, #fed9be 100%);

                  .x-data-vip-box-main-plan-rightTag {
                    color: #fff;
                    background: url("~/assets/icons/deli-module/pay-right-tag-active.png");
                    background-size: cover;
                  }

                  .x-data-vip-box-main-plan-leftTag {
                    color: #fff;
                    background: #ed6425;
                  }

                  .plan-price {
                    color: #f54a01;
                  }
                }

                .plan-original-price {
                  font-size: 20px;
                  color: #ce9676;
                  text-decoration: line-through;
                }
              }
            }
          }

          .company-vip-card {
            width: 100%;
            min-height: 294px;
            padding: 48px 64px;
            background-color: #fff8f0;

            .company-vip-box {
              display: flex;
              flex-wrap: wrap;
              gap: 25px;
              align-items: center;
              justify-content: center;

              .company-vip-item {
                position: relative;
                box-sizing: content-box;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;
                width: 0;
                min-width: 400px;
                height: auto;
                aspect-ratio: 625/198;
                cursor: pointer;
                background: #fff;
                border: 2px solid #ffe1d0;
                border-radius: 24px;

                .x-data-vip-box-main-plan-leftTag {
                  position: absolute;
                  top: 0;
                  left: 0;
                  padding: 4px 11px;
                  font-size: 12px;
                  color: #9b4f2e;
                  background: #ffe1d0;
                  border-radius: 23px 0;
                }

                .x-data-vip-box-main-plan-rightTag {
                  position: absolute;
                  top: -8px;
                  right: -4px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 34px;
                  height: 34px;
                  font-size: 8px;
                  font-weight: 500;
                  color: #a18b69;
                  text-align: center;
                  white-space: normal;
                  background: url("~/assets/icons/deli-module/pay-right-tag.png");
                  background-size: cover;
                }

                &.company-vip-recommend {
                  background-image: url("~/assets/images/legal-data/recommend-bg.svg");
                  background-repeat: no-repeat;
                  background-size: 100% 100%;

                  .company-vip-item-icon {
                    top: -18px;
                    font-size: 68px;
                  }

                  .company-vip-box {
                    .company-vip-left {
                      .company-vip-left-price {
                        .company-vip-left-price-plan {
                          color: #ed6425;
                        }
                      }
                    }
                  }
                }

                &.company-vip-item-selected {
                  border: 1px solid #ce854a;

                  .x-data-vip-box-main-plan-rightTag {
                    color: #fff;
                    background: url("~/assets/icons/deli-module/pay-right-tag-active.png");
                    background-size: cover;
                  }

                  .x-data-vip-box-main-plan-leftTag {
                    color: #fff;
                    background: #ed6425;
                  }
                }

                .company-vip-item-icon {
                  position: absolute;
                  top: -36px;
                  left: 0;
                  font-size: 104px;
                }

                .company-vip-box {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 0 56px;

                  .company-vip-right {
                    font-size: 24px;
                    font-weight: bold;
                    color: #18173e;
                  }

                  .company-vip-left {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: center;

                    .company-vip-left-price {
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;

                      .company-vip-left-price-plan {
                        font-size: 48px;
                        color: #683510;

                        &::before {
                          font-size: 32px;
                          content: "¥";
                        }
                      }

                      .company-vip-left-price-source {
                        font-size: 20px;
                        color: #b1682c;
                        text-decoration: line-through;

                        &::before {
                          text-decoration: none;
                          content: "原价：";
                        }

                        &::after {
                          text-decoration: none;
                          content: "/年";
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .legal-data-vip-card-footer {
          width: 100%;
          height: auto;
          padding-top: 48px;

          // .vip-card-member-rights {
          //   width: 100%; // 5列 * 280px
          //   margin-right: auto;
          //   margin-left: auto;

          //   .rights-title-box {
          //     display: flex;
          //     align-items: center;
          //     justify-content: center;
          //     margin-bottom: 72px;

          //     .rights-title {
          //       margin: 0 24px;
          //       font-size: var(--rights-title-font-size);
          //       font-weight: 500;
          //       line-height: 42px;
          //       color: transparent;
          //       text-align: center;
          //       background: linear-gradient(0deg, #ed9c1f 0%, #ea7a36 100%);
          //       background-clip: text;
          //     }

          //     .rights-title-box-line-left {
          //       width: var(--rights-title-box-line-width);
          //       height: 1px;
          //       background: linear-gradient(90deg, rgba(255, 195, 79, 0%) 0%, #ffc34f 100%);
          //       border-radius: 2px;
          //     }

          //     .rights-title-box-line-right {
          //       width: var(--rights-title-box-line-width);
          //       height: 1px;
          //       background: linear-gradient(90deg, #eb9762 0%, rgba(235, 151, 98, 0%) 100%);
          //       border-radius: 2px;
          //     }
          //   }

          //   .rights-table-box {
          //     width: 100%;
          //     height: auto;
          //   }
          // }
        }

        .lawyer-letter {
          .lawyer-letter-title {
            margin-top: 24px;
            margin-bottom: 12px;
            margin-left: 81px;
            font-size: 16px;
            color: #8b8b93;
          }

          .lawyer-letter-box {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 54px;
            padding: 0 81px;
            background: #fefefd;
            border: 1px solid #f1f1f1;
            border-radius: 10px;

            .lawyer-letter-item {
              display: flex;
              gap: 4px;
              align-items: center;
              justify-content: center;

              .lawyer-letter-item-label {
                font-size: 16px;
                color: #af997a;
              }

              .lawyer-letter-item-content {
                font-size: 16px;
                color: #3c3b5d;
              }
            }
          }
        }

        .legal-data-vip-card-footer-tips {
          margin-top: 16px;
          margin-left: 74px;

          .tips-title {
            margin-bottom: 12px;
            font-size: 16px;
            color: #8b8b93;
          }

          .legal-data-vip-card-footer-tips-box {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;

            .vip-times {
              font-size: 16px;
              color: #3c3b5d;

              strong {
                color: #fbbc05;
              }
            }
          }
        }
      }
    }
  }

  :deep(.customer-tips-overlay) {
    // width: 198px;
    width: 528px;
    height: 268px;
    border-radius: 24px;

    &.ant-tooltip {
      max-width: 35rem !important;
      padding: 0;
    }

    .ant-tooltip-inner {
      padding: 0 !important;
      background: none !important;
      box-shadow: none !important;
    }

    .ant-tooltip-arrow {
      display: none;

      &::before {
        background: #fff;
      }
    }

    .customer-code-pine {
      width: 528px;
      height: 268px;

      .qr-code {
        width: 106px;
        height: 106px;
      }

      .tip {
        font-size: 14px;
        color: #969696;
      }
    }
  }
</style>
<style lang="less">
  // 适配购买弹窗
  .legal-data-buy-modal {
    .x-purchase-plan-modal {
      .ant-modal {
        width: auto !important;
        min-width: 288px;
        max-width: 1323px;

        .x-purchase-plan {
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;

          .setmeal {
            width: 100vw;
            min-width: 288px;
            max-width: 928px;
            height: auto;
            min-height: 722px;
            margin-right: 0;

            .header {
              .desc {
                .desc-row {
                  flex-wrap: wrap;
                }
              }
            }

            .items {
              .items-plan {
                flex-wrap: wrap;
                gap: 32px;
                justify-content: center;

                .plan-item {
                  max-width: 230px;
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
